// extracted by mini-css-extract-plugin
module.exports = {"button":"provider-button_button__QYpku","disabled":"provider-button_disabled__2AD30","icon":"provider-button_icon__FWJyC"};